import { put, takeEvery, all } from 'redux-saga/effects'
import * as actions from '../actionTypes'

import {logError} from '../api'

export function* logErrorSaga(action){
    if(process.env.NODE_ENV === 'development')
      return
    
    const {email, error, info} = action.payload

    yield logError(email, error, info)

    yield put({type: actions.ERROR_LOGGED})
}

export const loggerSagas = [takeEvery(actions.LOG_ERROR, logErrorSaga)]

export function* rootLoggerSaga() {
    yield all([...loggerSagas])
}


// WEBPACK FOOTER //
// ./src/sagas/logger.js